<!doctype html>
<html lang="en">
  <head>
    <link rel="icon" type="image/x-icon" href="/favicon.ico">
    <link rel="apple-touch-icon" href="/logo192.png">
    <link rel="manifest" href="/manifest.json">
<meta name="theme-color" content="#0b1120">
<meta name="apple-mobile-web-app-capable" content="yes">
<meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
<meta name="apple-mobile-web-app-title" content="TASKBRIDGE">
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>TASKBRIDGE | Freelance, Affiliate and Online Jobs</title>
    <meta
      name="description"
      content="TASKBRIDGE is Africa's leading freelance, affiliate, and online jobs marketplace for ambitious digital talent."
    />
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet">
    <link rel="preconnect" href="https://images.unsplash.com" />
    <link rel="stylesheet" href="./styles.css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/tabler-icons.min.css" />
    <script defer src="https://unpkg.com/lucide@latest/dist/umd/lucide.js"></script>
    <script type="module" src="./app.js"></script>
  </head>
  <body class="is-dark">
    <!-- Top Banner -->
    <div class="top-banner" id="top-banner">
      <span class="top-banner-text">LEADING AFRICAN FREELANCE MARKETPLACE</span>
    </div>

    <header class="site-header" id="site-header">
      <a class="brand" href="#home" aria-label="TASKBRIDGE home" style="display:flex;align-items:center;gap:0.6rem;text-decoration:none;">
        <img src="./logo192.png" alt="TB" style="width:38px;height:38px;border-radius:8px;flex-shrink:0;">
        <div style="display:flex;flex-direction:column;line-height:1.1;">
          <span class="tb-brand-text">TASKBRIDGE</span>
          <span class="tb-brand-sub">FREELANCE PLATFORM</span>
        </div>
      </a>
      
      <nav class="desktop-nav">
        <a href="javascript:void(0)" data-action="signup">Browse Jobs</a>
        <a href="javascript:void(0)" data-action="signup">How It Works</a>
        <a href="javascript:void(0)" data-action="signup">Skills</a>
        <a href="javascript:void(0)" data-tab="institute">TASKBRIDGE INSTITUTE</a>
        <a href="javascript:void(0)" data-action="signup">About Us</a>
      </nav>

      <div class="header-actions" style="display:flex;gap:0.5rem;align-items:center;"></div>
    </header>

    <div class="menu-popover"></div>

    <main id="app" aria-live="polite"></main>

    <footer class="site-footer">
      <div>
        <strong>TASKBRIDGE</strong>
      </div>
      <div class="footer-links">
        <a href="#terms">Terms of Service</a>
        <a href="#privacy">Data Protection Policy</a>
        <a href="https://wa.me/254719105828" target="_blank">Help Desk</a>
      </div>
    </footer>
  </body>
</html>
